import { Endpoint } from 'src/actions/endpoints/endpointsResource';
import get from 'lodash/get';

export function getTwitterUserName(endpoint: Endpoint) {
  const name = get(endpoint, 'configuration.handle', '');
  return name.startsWith('@') ? name : `@${name}`;
}
